import React, { useCallback, useMemo } from "react";

import { cancellationTableColumnsConfig } from "./cancellationTableColumnsConfig";
import { Table } from "../../../component/table/Table";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCancellationState } from "../../../store/cancellationFilterSlice";
import {
  selectCancellations,
  useGetCancellationsListQuery,
} from "../../../services/cancellation/cancellationApiSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

export const CancellationTablePage = ({ data }) => {
  const appliedFilters = useSelector(selectCancellationState);
  const { isSuccess, isLoading, isFetching } =
    useGetCancellationsListQuery(appliedFilters);

  const tableData = useSelector(selectCancellations);
  const navigate = useNavigate();

  const handleNavigateToDetail = useCallback(
    (cancellationId) => {
      navigate(`/cancellations/${cancellationId}`);
    },
    [navigate],
  );

  const columnDefs = useMemo(
    () => cancellationTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail],
  );

  return isSuccess ? (
    <Table
      data={tableData}
      columns={columnDefs}
      loading={isLoading || isFetching}
    />
  ) : (
    <CategoryPageSkeleton />
  );
};
